import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[lfwmsTemplateRef]'
})
export class TemplateRefDirective {

  constructor(public templateRef: TemplateRef<any>) {}

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/directives/template-ref.directive.ts